<div class="theme-responses">
    <h4 class="section-title">Response Templates</h4>
    <p class="section-subtitle">
        Up to {{ maxResponses }} pre-defined response templates that producers
        can select from in the producer dashboard and send to listeners. Each
        response can include either text, an image, or both.
    </p>

    <div
        class="grid"
        cdkDropList
        cdkDropListOrientation="mixed"
        (cdkDropListDropped)="onDrop($event)"
    >
        @for (row of responses().controls; track row; let i = $index) {
            <div class="card response-card" cdkDrag [formGroup]="row">
                <div class="drag-handle" aria-hidden="true">
                    <span class="icon-select_drag"></span>
                </div>

                <div class="card-header">
                    <h5 class="card-title">Response {{ i + 1 }}</h5>
                    <!--
                        Always rendered: disabled and forced to read off until the card has a
                        short name plus response text or an image. The row's stored value is
                        untouched while disabled, so the user's last choice comes back with it.
                    -->
                    <tools-toggle
                        class="active-toggle"
                        [isChecked]="
                            canActivate(row) &&
                            row.controls.responseIsActive.value
                        "
                        [isDisabled]="!canActivate(row)"
                        (change)="
                            row.controls.responseIsActive.setValue(
                                $event.checked
                            )
                        "
                        (mousedown)="$event.stopPropagation()"
                        (touchstart)="$event.stopPropagation()"
                    >
                        Response is active
                    </tools-toggle>
                </div>

                <tools-input-outline
                    label="Short name"
                    placeholder="Enter a short name for internal use (listeners won't see this)"
                    [maxLength]="nameMaxLength"
                    formControlName="name"
                    (mousedown)="$event.stopPropagation()"
                    (touchstart)="$event.stopPropagation()"
                ></tools-input-outline>

                <app-image-upload
                    class="response-image"
                    label="response image"
                    promptText="Upload Image"
                    [initialUrl]="row.controls.imageUrl.value || null"
                    (uploaded)="onImageUploaded(row, $event)"
                ></app-image-upload>
                <p class="upload-hint">
                    JPEG, PNG, GIF, WebP, SVG. 5 MB maximum file size. Images
                    with a fill or a background are preferred.
                </p>

                <tools-textarea
                    placeholder="Enter a response (e.g., Thank you for your submission, we loved reading it!)."
                    [maxLength]="responseMaxLength"
                    formControlName="response"
                    (mousedown)="$event.stopPropagation()"
                    (touchstart)="$event.stopPropagation()"
                ></tools-textarea>
                @if (needsName(row)) {
                    <span class="error">
                        Enter a short name — a response can’t be saved without
                        one.
                    </span>
                }
                @if (needsContent(row)) {
                    <span class="error">
                        Add response text or an image — a response can’t be
                        saved with only a short name.
                    </span>
                }
            </div>
        }
    </div>
</div>
